import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { ButtonView } from 'ckeditor5/src/ui';
import removeFormatIcon from './remove-format.svg';

const REMOVE_FORMAT = 'removeFormat';

export class SBRemoveFormatPlugin extends Plugin {

    static get pluginName() {
        return 'SBRemoveFormat';
    }

    init() {
        const editor = this.editor;
        const t = editor.t;

        editor.ui.componentFactory.add( 'sbRemoveFormat', locale => {
            const command = editor.commands.get( REMOVE_FORMAT );
            const view = new ButtonView( locale );

            view.set( {
                label: t( 'Remove Format' ),
                icon: removeFormatIcon,
                tooltip: true,
                isEnabled: true,
            } );

            // Execute the command.
            this.listenTo( view, 'execute', () => {
                this.removeFormatting();
                editor.editing.view.focus();
            } );

            return view;
        } );
    }

    refresh() {

    }

    removeFormatting() {
        const model = this.editor.model;
        const schema = model.schema;

        model.change( writer => {
            for ( const item of this._getFormattingItems( model.document.selection, schema ) ) {
                if ( item.is( 'selection' ) ) {
                    for ( const attributeName of this._getFormattingAttributes( item, schema ) ) {
                        writer.removeSelectionAttribute( attributeName );
                    }
                } else {
                    // Workaround for items with multiple removable attributes. See
                    // https://github.com/ckeditor/ckeditor5-remove-format/pull/1#pullrequestreview-220515609
                    const itemRange = writer.createRangeOn( item );
                    for ( const attributeName of this._getFormattingAttributes( item, schema ) ) {
                        writer.removeAttribute( attributeName, itemRange );
                    }
                }
            }
        } );
    }

    * _getFormattingAttributes( item, schema ) {
        for ( const [ attributeName ] of item.getAttributes() ) {
            yield attributeName;
        }
    }

    * _getFormattingItems( selection, schema ) {
        // Check formatting on selected items that are not blocks.
        for ( const curRange of selection.getRanges() ) {
            for ( const item of curRange.getItems() ) {
                if ( !schema.isBlock( item ) ) {
                    yield item;
                }
            }
        }

        // Check formatting from selected blocks.
        for ( const block of selection.getSelectedBlocks() ) {
            yield block;
        }

        yield selection;
    }
}
